import { Box, Grid, Skeleton } from "@mui/material";
import { SkeletonTab, SkeletonTabs } from "@pmag/ui-components";
import { ArticleHeaderSkeleton } from "@src/pages/componentGroupOverview/components/articleHeader/ArticleHeaderSkeleton";
import { type FunctionComponent } from "react";

import { SkeletonContent } from "./SubgroupDetailPage.styles";
import { ControlPanelContainer, TopContainer } from "./subgroupDetailsListSection/controlPanel/ControlPanel.styles";

export const SubgroupDetailPageSkeleton: FunctionComponent = ({ ...restProps }) => {
    return (
        <Box {...restProps} mb={5}>
            <ArticleHeaderSkeleton />

            <SkeletonContent>
                <Grid
                    columnSpacing={8}
                    container
                    columns={{
                        lg: 12,
                        md: 12,
                        sm: 8,
                        xl: 12,
                        xs: 4,
                    }}
                >
                    <Grid item xs={8} md={8}>
                        <ControlPanelContainer>
                            <TopContainer>
                                <Skeleton height={32} width={50} />

                                <Skeleton height={32} sx={{ flex: 1 }} />
                            </TopContainer>
                        </ControlPanelContainer>

                        <Box display="flex" justifyContent="space-between" mt={4} mb={3}>
                            <SkeletonTabs>
                                <SkeletonTab forwardSize="small" />

                                <SkeletonTab forwardSize="small" />

                                <SkeletonTab forwardSize="small" />
                            </SkeletonTabs>

                            <Skeleton height={32} width={32} />
                        </Box>

                        <Box gap={1} display="flex" flexDirection="column">
                            <Skeleton height={40} />

                            <Skeleton height={40} />

                            <Skeleton height={40} />

                            <Skeleton height={40} />
                        </Box>
                    </Grid>

                    <Grid item xs={8} md={4}>
                        <Skeleton height="100%" />
                    </Grid>
                </Grid>
            </SkeletonContent>
        </Box>
    );
};
